//@ts-check
import { endpoint } from '../net/endpoints.js';
import { USE_OLD_RANGER } from './RcsConstants.js';

/** Non-production ranger PoC backend used only with {@link USE_OLD_RANGER}. */
const OLD_RANGER_PROXY_URL = 'https://vds.dev.usa.autodesk.com/ranger';

/**
 * Returns the remote ranger proxy base URL for RCS WebSocket range requests.
 * Uses the same CDN endpoint as SVF2/OTG ({@link endpoint.getCdnUrl}), so staging,
 * production, and region-specific routing stay aligned with the viewer environment.
 * @returns {string|null}
 */
export function getRcsRemoteProxyUrl() {
  if (USE_OLD_RANGER) {
    return OLD_RANGER_PROXY_URL;
  }
  // Use || null (not ?? null): also coerces empty-string results from the
  // _endpoint + cdnURL fallback in endpoint.getCdnUrl().
  // @ts-expect-error getCdnUrl is attached to endpoint at module init
  return endpoint.getCdnUrl() || null;
}